/* ============================================
   URBAN FURNISHING – Custom Homepage Scripts
   Shopify Theme Integration
   ============================================ */

function initUFHomepage() {
    initUFHeroMarquee();
    initUFFeaturesMarquee();
    initUFFAQAccordion();
    initUFCategoryCarousel();
    initUFProductsCarousel();
    initUFSmoothInteractions();
    initUFProductCardSwatches();
    initUFVideoReels();
    initUFTestimonialsMarquee();
}

if (!window.ufHomepageInitBound) {
    window.ufHomepageInitBound = true;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initUFHomepage, { once: true });
    } else {
        initUFHomepage();
    }
}

/* ---------- Hero Side Slider (Auto Step-by-Step Card Motion + Clickable) ---------- */
function initUFHeroMarquee() {
    const track = document.querySelector(".hero__side-track");
    const prev = document.getElementById("hero-prev");
    const next = document.getElementById("hero-next");

    if (!track || !prev || !next) return;

    // Filter out any previously cloned cards
    const originals = Array.from(track.children).filter(c => !c.dataset.cloned);
    if (originals.length === 0) return;

    // Tag original cards with their index
    originals.forEach((card, idx) => {
        card.dataset.cardIdx = idx;
    });

    // Rebuild track with 3 clean sets for infinite step navigation
    track.innerHTML = '';
    for (let set = 0; set < 3; set++) {
        originals.forEach((card) => {
            const clone = card.cloneNode(true);
            if (set > 0) clone.dataset.cloned = "true";
            track.appendChild(clone);
        });
    }

    const totalOriginals = originals.length;
    let currentOriginalIdx = 0; // 0..totalOriginals-1
    let setOffset = 0; // set index offset
    let autoSlideInterval = null;

    function getCardStepWidth() {
        const gap = parseFloat(getComputedStyle(track).gap) || 16;
        const firstCard = track.children[0];
        const width = firstCard ? firstCard.offsetWidth : 194;
        return width + gap;
    }

    function updateTrackPosition(smooth = true) {
        const stepWidth = getCardStepWidth();
        const cardPositionIdx = setOffset * totalOriginals + currentOriginalIdx;
        const translateX = cardPositionIdx * stepWidth;

        if (smooth) {
            track.style.transition = 'transform 0.45s cubic-bezier(0.25, 1, 0.5, 1)';
        } else {
            track.style.transition = 'none';
        }
        track.style.transform = `translateX(-${translateX}px)`;

        // Highlight active side card across all sets
        const allCards = Array.from(track.children);
        allCards.forEach((card) => {
            const cardIdx = parseInt(card.dataset.cardIdx, 10);
            card.classList.toggle('hero__side-card--active', cardIdx === currentOriginalIdx);
        });

        // Update Main Banner Content dynamically
        const activeCard = originals[currentOriginalIdx];
        if (activeCard) {
            const cardTitle = activeCard.dataset.title || activeCard.querySelector('.hero__side-title')?.textContent?.trim();
            const cardImg = activeCard.dataset.image || activeCard.querySelector('img')?.src;
            const cardUrl = activeCard.dataset.url || activeCard.getAttribute('href');

            if (cardTitle) {
                const heroProdNameEl = document.querySelector('.hero__product-name');
                if (heroProdNameEl) heroProdNameEl.textContent = cardTitle;
            }

            if (cardImg) {
                const heroBannerImg = document.querySelector('.hero__banner-image img');
                if (heroBannerImg) heroBannerImg.src = cardImg;
            }

            if (cardUrl && cardUrl !== '#') {
                const viewBtn = document.querySelector('.hero__view-btn');
                if (viewBtn) viewBtn.setAttribute('href', cardUrl);
            }

            // Sync top header navigation tabs
            if (cardTitle) {
                const navLinks = document.querySelectorAll('.ch-nav a, .banner-with-tabs__button');
                navLinks.forEach(link => {
                    const linkText = link.textContent.trim().toLowerCase();
                    const titleText = cardTitle.trim().toLowerCase();
                    if (linkText && titleText && (linkText === titleText || titleText.includes(linkText) || linkText.includes(titleText))) {
                        link.classList.add('active', 'banner-with-tabs__button--active');
                    } else {
                        link.classList.remove('active', 'banner-with-tabs__button--active');
                    }
                });
            }
        }
    }

    function goToSlide(targetIdx, smooth = true) {
        if (targetIdx >= totalOriginals) {
            setOffset++;
            currentOriginalIdx = targetIdx % totalOriginals;
            if (setOffset >= 2) {
                updateTrackPosition(smooth);
                setTimeout(() => {
                    setOffset = 0;
                    updateTrackPosition(false);
                }, 450);
                return;
            }
        } else if (targetIdx < 0) {
            if (setOffset > 0) {
                setOffset--;
                currentOriginalIdx = (targetIdx % totalOriginals + totalOriginals) % totalOriginals;
            } else {
                setOffset = 1;
                currentOriginalIdx = totalOriginals - 1;
                updateTrackPosition(false);
                setTimeout(() => {
                    currentOriginalIdx = totalOriginals - 1;
                    updateTrackPosition(smooth);
                }, 20);
                return;
            }
        } else {
            currentOriginalIdx = targetIdx;
        }
        updateTrackPosition(smooth);
    }

    function startAutoPlay() {
        stopAutoPlay();
        autoSlideInterval = setInterval(() => {
            goToSlide(currentOriginalIdx + 1, true);
        }, 3500); // Auto slide every 3.5 seconds
    }

    function stopAutoPlay() {
        if (autoSlideInterval) {
            clearInterval(autoSlideInterval);
            autoSlideInterval = null;
        }
    }

    // Initial position & start auto slide
    updateTrackPosition(false);
    startAutoPlay();

    // Pause auto slide on hover
    track.addEventListener("mouseenter", stopAutoPlay);
    track.addEventListener("mouseleave", startAutoPlay);

    // Next button moves forward 1 card step
    next.addEventListener("click", (e) => {
        e.preventDefault();
        goToSlide(currentOriginalIdx + 1, true);
        startAutoPlay();
    });

    // Prev button moves backward 1 card step
    prev.addEventListener("click", (e) => {
        e.preventDefault();
        goToSlide(currentOriginalIdx - 1, true);
        startAutoPlay();
    });

    // Handle clicks on side cards (clickable selection + navigation)
    track.addEventListener("click", (e) => {
        const card = e.target.closest(".hero__side-card");
        if (!card) return;
        
        const cardIdx = parseInt(card.dataset.cardIdx, 10);
        if (!isNaN(cardIdx)) {
            if (cardIdx === currentOriginalIdx) {
                const url = card.dataset.url || card.getAttribute('href');
                if (url && url !== '#') {
                    window.location.href = url;
                    return;
                }
            }
            e.preventDefault();
            goToSlide(cardIdx, true);
            startAutoPlay();
        }
    });

    // Touch & Swipe gestures for Hero Side Slider
    let heroTouchStartX = 0;
    track.addEventListener("touchstart", (e) => {
        stopAutoPlay();
        heroTouchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener("touchend", (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = heroTouchStartX - touchEndX;
        if (Math.abs(diff) > 30) {
            if (diff > 0) {
                goToSlide(currentOriginalIdx + 1, true);
            } else {
                goToSlide(currentOriginalIdx - 1, true);
            }
        }
        startAutoPlay();
    }, { passive: true });

    // Sync tab navigation clicks
    document.querySelectorAll('.ch-nav a, .banner-with-tabs__button').forEach(navLink => {
        navLink.addEventListener('click', (e) => {
            const linkText = navLink.textContent.trim().toLowerCase();
            if (!linkText) return;
            const matchingIndex = originals.findIndex(card => {
                const t = (card.dataset.title || card.querySelector('.hero__side-title')?.textContent || '').trim().toLowerCase();
                return t === linkText || t.includes(linkText) || linkText.includes(t);
            });
            if (matchingIndex !== -1) {
                e.preventDefault();
                goToSlide(matchingIndex, true);
                startAutoPlay();
            }
        });
    });

    window.addEventListener("resize", () => {
        updateTrackPosition(false);
    });
}

/* ---------- FAQ Accordion ---------- */
function initUFFAQAccordion() {
    const faqContainers = document.querySelectorAll('.custom-homepage .faq__right, .faq__right');

    faqContainers.forEach(container => {
        const faqItems = container.querySelectorAll('.faq__item');

        faqItems.forEach(item => {
            const question = item.querySelector('.faq__question');
            if (!question || question.dataset.faqBound) return;
            question.dataset.faqBound = 'true';

            question.addEventListener('click', () => {
                const isActive = item.classList.contains('faq__item--active');

                // Close sibling items in this container
                faqItems.forEach(i => {
                    i.classList.remove('faq__item--active');
                    const btn = i.querySelector('.faq__question');
                    if (btn) btn.setAttribute('aria-expanded', 'false');

                    const toggle = i.querySelector('.faq__toggle');
                    if (toggle) {
                        toggle.innerHTML = `
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <line x1="12" y1="5" x2="12" y2="19"/>
                                <line x1="5" y1="12" x2="19" y2="12"/>
                            </svg>`;
                    }
                });

                // Open clicked item (if it wasn't already open)
                if (!isActive) {
                    item.classList.add('faq__item--active');
                    question.setAttribute('aria-expanded', 'true');

                    const toggle = item.querySelector('.faq__toggle');
                    if (toggle) {
                        toggle.innerHTML = `
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <line x1="5" y1="12" x2="19" y2="12"/>
                            </svg>`;
                    }
                }
            });
        });
    });
}

/* ---------- Category Carousel (Auto Step-by-Step 1 Slide Motion + Touch Swipe) ---------- */
function initUFCategoryCarousel() {
    const sections = document.querySelectorAll('.category');

    sections.forEach((section) => {
        const grid = section.querySelector('.category__grid');
        const prevBtn = section.querySelector('.nav-arrow--left');
        const nextBtn = section.querySelector('.nav-arrow--right');
        const nav = section.querySelector('.section-nav');

        if (!grid || grid.dataset.carouselInitialized === 'true') return;
        grid.dataset.carouselInitialized = 'true';

        const desktopSliderEnabled = section.dataset.desktopSlider !== 'false';
        let autoTimer = null;

        function sliderEnabled() {
            return window.innerWidth <= 768 || desktopSliderEnabled;
        }

        function getStepWidth() {
            const firstCard = grid.querySelector('.category__card');
            const styles = window.getComputedStyle(grid);
            const gap = parseFloat(styles.columnGap || styles.gap) || 0;
            return (firstCard ? firstCard.offsetWidth : 240) + gap;
        }

        function hasOverflow() {
            const cardCount = grid.querySelectorAll('.category__card').length;
            const visibleItemSetting = window.innerWidth <= 768
                ? section.dataset.mobileItems
                : section.dataset.desktopItems;
            const visibleItemCount = parseInt(visibleItemSetting, 10) || 1;

            return cardCount > visibleItemCount;
        }

        function updateSliderState() {
            const enabled = sliderEnabled() && hasOverflow();
            if (nav) nav.style.display = enabled ? 'flex' : 'none';

            if (enabled) {
                startAutoSlide();
            } else {
                stopAutoSlide();
                grid.scrollTo({ left: 0 });
            }
        }

        function slideNext() {
            if (!sliderEnabled()) return;
            const stepWidth = getStepWidth();
            const maxScroll = grid.scrollWidth - grid.clientWidth;
            if (grid.scrollLeft + stepWidth >= maxScroll - 10) {
                grid.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                grid.scrollBy({ left: stepWidth, behavior: 'smooth' });
            }
        }

        function slidePrev() {
            if (!sliderEnabled()) return;
            const stepWidth = getStepWidth();
            if (grid.scrollLeft <= 10) {
                const maxScroll = grid.scrollWidth - grid.clientWidth;
                grid.scrollTo({ left: maxScroll, behavior: 'smooth' });
            } else {
                grid.scrollBy({ left: -stepWidth, behavior: 'smooth' });
            }
        }

        function startAutoSlide() {
            stopAutoSlide();
            if (sliderEnabled() && hasOverflow()) {
                autoTimer = setInterval(slideNext, 3500);
            }
        }

        function stopAutoSlide() {
            if (autoTimer) {
                clearInterval(autoTimer);
                autoTimer = null;
            }
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                slideNext();
                startAutoSlide();
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                slidePrev();
                startAutoSlide();
            });
        }

        let catTouchStartX = 0;
        grid.addEventListener('touchstart', (e) => {
            stopAutoSlide();
            catTouchStartX = e.touches[0].clientX;
        }, { passive: true });

        grid.addEventListener('touchend', (e) => {
            const touchEndX = e.changedTouches[0].clientX;
            const diff = catTouchStartX - touchEndX;
            if (Math.abs(diff) > 30) {
                if (diff > 0) {
                    slideNext();
                } else {
                    slidePrev();
                }
            }
            startAutoSlide();
        }, { passive: true });

        grid.addEventListener('mouseenter', stopAutoSlide);
        grid.addEventListener('mouseleave', startAutoSlide);
        window.addEventListener('resize', updateSliderState);

        updateSliderState();
    });
}

/* ---------- Products Carousel (Touch Swipe + Nav Buttons) ---------- */
function initUFProductsCarousel() {
    const prodGrid = document.getElementById('products-grid');
    const prodPrev = document.getElementById('prod-prev');
    const prodNext = document.getElementById('prod-next');

    if (!prodGrid) return;

    function updateProductsArrows() {
        const maxScroll = prodGrid.scrollWidth - prodGrid.clientWidth;
        const navContainer = prodPrev?.closest('.section-nav') || prodNext?.closest('.section-nav');
        if (maxScroll <= 5) {
            if (navContainer) navContainer.style.display = 'none';
            if (prodPrev) prodPrev.style.display = 'none';
            if (prodNext) prodNext.style.display = 'none';
        } else {
            if (navContainer) navContainer.style.display = 'flex';
            if (prodPrev) {
                prodPrev.style.display = 'flex';
                prodPrev.style.opacity = prodGrid.scrollLeft <= 5 ? '0.3' : '1';
                prodPrev.style.pointerEvents = prodGrid.scrollLeft <= 5 ? 'none' : 'auto';
            }
            if (prodNext) {
                prodNext.style.display = 'flex';
                prodNext.style.opacity = (prodGrid.scrollLeft + prodGrid.clientWidth >= prodGrid.scrollWidth - 5) ? '0.3' : '1';
                prodNext.style.pointerEvents = (prodGrid.scrollLeft + prodGrid.clientWidth >= prodGrid.scrollWidth - 5) ? 'none' : 'auto';
            }
        }
    }

    if (prodPrev && prodNext) {
        prodPrev.addEventListener('click', () => {
            prodGrid.scrollBy({ left: -300, behavior: 'smooth' });
        });
        prodNext.addEventListener('click', () => {
            prodGrid.scrollBy({ left: 300, behavior: 'smooth' });
        });
    }

    // Touch Swipe Gestures
    let prodTouchStartX = 0;
    prodGrid.addEventListener('touchstart', (e) => {
        prodTouchStartX = e.touches[0].clientX;
    }, { passive: true });

    prodGrid.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = prodTouchStartX - touchEndX;
        if (Math.abs(diff) > 30) {
            if (diff > 0) {
                prodGrid.scrollBy({ left: 300, behavior: 'smooth' });
            } else {
                prodGrid.scrollBy({ left: -300, behavior: 'smooth' });
            }
        }
    }, { passive: true });

    prodGrid.addEventListener('scroll', updateProductsArrows, { passive: true });
    window.addEventListener('resize', updateProductsArrows);
    updateProductsArrows();
}

/* ---------- Smooth Interactions & Animations ---------- */
function initUFSmoothInteractions() {
    // Stat counter animation
    const statNumbers = document.querySelectorAll('.custom-homepage .testimonials__stat-number');
    const statsObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                ufAnimateCounter(entry.target);
                statsObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    statNumbers.forEach(el => statsObserver.observe(el));

    // Newsletter subscribe button
    const subscribeBtn = document.querySelector('.custom-footer .footer__subscribe-btn');
    const emailInput = document.querySelector('.custom-footer .footer__input');

    if (subscribeBtn && emailInput) {
        subscribeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (emailInput.value && emailInput.value.includes('@')) {
                subscribeBtn.textContent = '✓ Subscribed';
                emailInput.value = '';
                setTimeout(() => {
                    subscribeBtn.innerHTML = `Subscribe <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7552 24.9856C17.4992 25.0189 17.2387 24.9942 16.9921 24.9135C16.7456 24.8327 16.519 24.6977 16.3284 24.5182C16.1784 24.377 16.0528 24.2112 15.9567 24.0277L11.4188 15.6195C11.3738 15.5362 11.3554 15.4407 11.3663 15.3465C11.3771 15.2524 11.4167 15.1643 11.4793 15.0948L16.8905 9.0849C16.9728 8.99391 17.0357 8.88647 17.0754 8.76925C17.1151 8.65203 17.1307 8.52753 17.1212 8.40349C17.1118 8.27945 17.0774 8.15852 17.0204 8.0482C16.9633 7.93789 16.8847 7.84054 16.7895 7.76222C16.6072 7.61871 16.379 7.5504 16.1507 7.57095C15.9224 7.5915 15.7109 7.6994 15.5584 7.87305L10.1689 13.8588C10.1063 13.9284 10.0237 13.976 9.93279 13.9949C9.84187 14.0138 9.74719 14.0031 9.6621 13.9642L1.08207 10.0454C0.749773 9.89851 0.468365 9.65214 0.275321 9.33907C0.0822765 9.02601 -0.0132442 8.6611 0.00147843 8.29294C0.0162011 7.92478 0.140469 7.57084 0.357733 7.27825C0.574998 6.98566 0.874949 6.7683 1.21765 6.65512L21.6663 0.0868488C21.9657 -0.0115511 22.286 -0.026639 22.5943 0.0431339C22.9026 0.112907 23.1879 0.265028 23.4208 0.483886C23.6537 0.702744 23.8258 0.980458 23.9196 1.28853C24.0134 1.5966 24.0254 1.92393 23.9543 2.23694L19.2577 23.6028C19.1786 23.9644 18.9917 24.2913 18.7228 24.5388C18.4538 24.7863 18.1159 24.9424 17.7552 24.9856Z" fill="white"/></svg>`;
                }, 2000);
            }
        });
    }
}

/* ---------- Counter Animation ---------- */
function ufAnimateCounter(element) {
    const text = element.textContent;
    const match = text.match(/(\d+)/);
    if (!match) return;

    const target = parseInt(match[1]);
    const suffix = text.replace(match[1], '');
    const duration = 1500;
    const start = performance.now();

    function update(currentTime) {
        const elapsed = currentTime - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.floor(eased * target);
        element.textContent = current + suffix;

        if (progress < 1) {
            requestAnimationFrame(update);
        } else {
            element.textContent = text;
        }
    }
    requestAnimationFrame(update);
}

function initUFProductCardSwatches() {
    document.querySelectorAll('.products__card').forEach(card => {
        const imageEl = card.querySelector('.product-card-image');
        const linkEl = card.querySelector('.products__image');
        const titleLinkEl = card.querySelector('.products__name a');
        const variantInput = card.querySelector('.variant-id-input');
        const swatches = card.querySelectorAll('.swatch-btn');
        if (!swatches.length) return;
        swatches.forEach(swatch => {
            swatch.addEventListener('click', (e) => {
                e.preventDefault();
                
                // Update selected state (visual)
                swatches.forEach(s => s.style.boxShadow = 'none');
                swatch.style.boxShadow = '0 0 0 2px #fff, 0 0 0 4px #000';
                
                // Update image
                const newImage = swatch.dataset.variantImage;
                if (newImage && imageEl) {
                    imageEl.src = newImage;
                    imageEl.srcset = '';
                }
                // Update links
                const newUrl = swatch.dataset.variantUrl;
                if (newUrl) {
                    if (linkEl) linkEl.href = newUrl;
                    if (titleLinkEl) titleLinkEl.href = newUrl;
                }
                // Update add to cart form variant id
                const newId = swatch.dataset.variantId;
                if (newId && variantInput) {
                    variantInput.value = newId;
                }
            });
            
            // Add hover effect
            swatch.addEventListener('mouseenter', () => {
                swatch.style.transform = 'scale(1.2)';
            });

              swatch.addEventListener('mouseleave', () => {
                swatch.style.transform = 'scale(1)';
            });
            swatch.style.transition = 'transform 0.2s, box-shadow 0.2s';
            swatch.style.cursor = 'pointer';
        });
    });
}

/* ---------- Features Section Marquee ---------- */
function initUFFeaturesMarquee() {
    const track = document.querySelector(".features__track");
    if (!track) return;

    const originals = Array.from(track.children).filter(c => !c.dataset.cloned);
    if (originals.length === 0) return;

    // Clone 3 sets for smooth infinite seamless loop
    track.innerHTML = '';
    for (let set = 0; set < 3; set++) {
        originals.forEach((item) => {
            const clone = item.cloneNode(true);
            if (set > 0) clone.dataset.cloned = "true";
            track.appendChild(clone);
        });
    }

    let position = 0;
    let speed = 0.6; // Continuous marquee speed
    let userPaused = false;

    function getOneSetWidth() {
        let gap = parseFloat(getComputedStyle(track).gap) || 48;
        let total = 0;
        for (let i = 0; i < originals.length; i++) {
            const child = track.children[i];
            total += (child ? child.offsetWidth : 200) + gap;
        }
        return total;
    }

    let oneSetWidth = getOneSetWidth();
    window.addEventListener("resize", () => {
        oneSetWidth = getOneSetWidth();
    });

    function tick() {
        if (!userPaused && oneSetWidth > 0) {
            position += speed;
            if (position >= oneSetWidth) {
                position -= oneSetWidth;
            }
            track.style.transform = `translateX(-${position}px)`;
        }
        requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    track.addEventListener("mouseenter", () => (userPaused = true));
    track.addEventListener("mouseleave", () => (userPaused = false));
}

/* ---------- Showcase Collection / Testimonials Vertical Marquee ---------- */
function initUFTestimonialsMarquee() {
    const tracks = document.querySelectorAll(".testimonials__marquee-track");
    if (!tracks.length) return;

    tracks.forEach((track) => {
        const originals = Array.from(track.children).filter(c => !c.dataset.cloned);
        if (originals.length === 0) return;

        // Clone 3 sets for smooth infinite seamless loop
        track.innerHTML = '';
        for (let set = 0; set < 3; set++) {
            originals.forEach((item) => {
                const clone = item.cloneNode(true);
                if (set > 0) clone.dataset.cloned = "true";
                track.appendChild(clone);
            });
        }

        let position = 0;
        let speed = 0.6; // Continuous marquee speed
        let userPaused = false;

        function getOneSetHeight() {
            let gap = parseFloat(getComputedStyle(track).gap) || 16;
            let total = 0;
            for (let i = 0; i < originals.length; i++) {
                const child = track.children[i];
                total += (child ? child.offsetHeight : 250) + gap;
            }
            return total;
        }

        let oneSetHeight = getOneSetHeight();
        window.addEventListener("resize", () => {
            oneSetHeight = getOneSetHeight();
        });

        // Remove CSS animation so JS handles infinite position smoothly
        track.style.animation = 'none';

        function tick() {
            if (!userPaused && oneSetHeight > 0) {
                position += speed;
                if (position >= oneSetHeight) {
                    position -= oneSetHeight;
                }
                track.style.transform = `translateY(-${position}px)`;
            }
            requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);

        track.addEventListener("mouseenter", () => (userPaused = true));
        track.addEventListener("mouseleave", () => (userPaused = false));
        track.addEventListener("touchstart", () => (userPaused = true), { passive: true });
        track.addEventListener("touchend", () => (userPaused = false), { passive: true });
    });
}

/* ---------- Shoppable Video Reels Controller ---------- */
function initUFVideoReels() {
    const sections = document.querySelectorAll('.video-reels');
    if (!sections.length) return;

    sections.forEach((sec) => {
        const secId = sec.id.replace('video-reels-', '');
        const wrapper = sec.querySelector('.video-reels__wrapper');
        const track = document.getElementById(`video-reels-track-${secId}`) || sec.querySelector('.video-reels__track');
        const prevBtn = document.getElementById(`reels-prev-${secId}`) || sec.querySelector('.nav-arrow--left');
        const nextBtn = document.getElementById(`reels-next-${secId}`) || sec.querySelector('.nav-arrow--right');

        if (!track || !wrapper) return;
        if (track.dataset.reelsInitialized === 'true') return;
        track.dataset.reelsInitialized = 'true';

        // Filter out previously cloned cards
        const originals = Array.from(track.children).filter(c => !c.dataset.cloned);
        const totalOriginals = originals.length;
        if (totalOriginals === 0) return;

        originals.forEach((card, idx) => {
            card.dataset.cardIdx = idx;
        });

        // Hide navigation if single item
        if (totalOriginals <= 1) {
            const nav = sec.querySelector('.section-nav');
            if (nav) nav.style.display = 'none';
            originals[0]?.classList.add('is-active');
            const video = originals[0]?.querySelector('video');
            if (video) video.play().catch(() => {});
            return;
        }

        // Rebuild track with 3 clean sets for seamless infinite loop
        track.innerHTML = '';
        for (let set = 0; set < 3; set++) {
            originals.forEach((card) => {
                const clone = card.cloneNode(true);
                if (set > 0) clone.dataset.cloned = 'true';
                track.appendChild(clone);
            });
        }

        const allCards = Array.from(track.children);
        allCards.forEach((card, i) => {
            card.dataset.trackIndex = i;
        });

        // Start with center item active (index 2: Sofia 5 Drawer Chest)
        const initialOriginalIdx = Math.min(2, totalOriginals - 1);
        let currentIndex = totalOriginals + initialOriginalIdx;
        let isTransitioning = false;
        let autoTimer = null;
        let isMuted = true;

        function getStepWidth() {
            const styles = window.getComputedStyle(track);
            const gap = parseFloat(styles.columnGap || styles.gap) || 20;
            const firstCard = allCards[0];
            const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 220;
            return cardWidth + gap;
        }

        function updateActiveCard() {
            const activeCard = allCards[currentIndex];
            allCards.forEach((card) => {
                const video = card.querySelector('video');
                if (card === activeCard) {
                    card.classList.add('is-active');
                    if (video && video.paused) {
                        video.muted = isMuted;
                        video.play().catch(() => {});
                    }
                } else {
                    card.classList.remove('is-active');
                    if (video && !video.paused) {
                        video.pause();
                    }
                }
            });
        }

        function updatePosition(smooth = true) {
            const stepWidth = getStepWidth();
            const firstCard = allCards[0];
            const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 220;
            const wrapperWidth = wrapper.getBoundingClientRect().width;
            const paddingLeft = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;

            const cardCenter = paddingLeft + (currentIndex * stepWidth) + (cardWidth / 2);
            const translateX = cardCenter - (wrapperWidth / 2);

            if (smooth) {
                track.style.transition = 'transform 0.45s cubic-bezier(0.25, 1, 0.5, 1)';
            } else {
                track.style.transition = 'none';
            }
            track.style.transform = `translateX(-${translateX}px)`;
            updateActiveCard();
        }

        function normalizeIndex() {
            if (currentIndex >= 2 * totalOriginals) {
                currentIndex -= totalOriginals;
                updatePosition(false);
            } else if (currentIndex < totalOriginals) {
                currentIndex += totalOriginals;
                updatePosition(false);
            }
        }

        function goToSlide(targetIndex, smooth = true) {
            currentIndex = targetIndex;
            updatePosition(smooth);

            if (smooth) {
                isTransitioning = true;
                setTimeout(() => {
                    normalizeIndex();
                    isTransitioning = false;
                }, 460);
            } else {
                normalizeIndex();
            }
        }

        function slideNext() {
            if (isTransitioning) return;
            goToSlide(currentIndex + 1, true);
        }

        function slidePrev() {
            if (isTransitioning) return;
            goToSlide(currentIndex - 1, true);
        }

        function startAuto() {
            stopAuto();
            autoTimer = setInterval(() => {
                slideNext();
            }, 3800);
        }

        function stopAuto() {
            if (autoTimer) {
                clearInterval(autoTimer);
                autoTimer = null;
            }
        }

        // Navigation arrow buttons
        if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                slideNext();
                startAuto();
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                slidePrev();
                startAuto();
            });
        }

        // Pause on hover
        sec.addEventListener('mouseenter', stopAuto);
        sec.addEventListener('mouseleave', startAuto);

        // Sound Toggle Button delegation
        function toggleSound() {
            isMuted = !isMuted;
            sec.querySelectorAll('.video-reels__video').forEach((v) => {
                v.muted = isMuted;
            });
            sec.querySelectorAll('.video-reels__sound-btn').forEach((btn) => {
                const iconOff = btn.querySelector('.icon-sound-off');
                const iconOn = btn.querySelector('.icon-sound-on');
                if (iconOff) iconOff.style.display = isMuted ? 'block' : 'none';
                if (iconOn) iconOn.style.display = isMuted ? 'none' : 'block';
            });
        }

        // Click delegation on track
        track.addEventListener('click', (e) => {
            const soundBtn = e.target.closest('.video-reels__sound-btn');
            if (soundBtn) {
                e.stopPropagation();
                e.preventDefault();
                toggleSound();
                return;
            }

            // Let product links or cart button on active card navigate normally
            if (e.target.closest('.video-reels__prod-link, .video-reels__cart-btn')) {
                return;
            }

            // Clicking any card brings it to center
            const card = e.target.closest('.video-reels__card');
            if (card) {
                const trackIdx = parseInt(card.dataset.trackIndex, 10);
                if (!isNaN(trackIdx) && trackIdx !== currentIndex) {
                    e.preventDefault();
                    goToSlide(trackIdx, true);
                    startAuto();
                }
            }
        });

        // Touch & Swipe gestures
        let touchStartX = 0;
        let touchEndX = 0;
        let isTouching = false;

        wrapper.addEventListener('touchstart', (e) => {
            stopAuto();
            touchStartX = e.touches[0].clientX;
            touchEndX = touchStartX;
            isTouching = true;
        }, { passive: true });

        wrapper.addEventListener('touchmove', (e) => {
            if (!isTouching) return;
            touchEndX = e.touches[0].clientX;
        }, { passive: true });

        wrapper.addEventListener('touchend', () => {
            if (!isTouching) return;
            isTouching = false;
            const diff = touchStartX - touchEndX;
            if (Math.abs(diff) > 35) {
                if (diff > 0) {
                    slideNext();
                } else {
                    slidePrev();
                }
            }
            startAuto();
        }, { passive: true });

        // Window resize handler
        window.addEventListener('resize', () => {
            updatePosition(false);
        });

        // Initial setup
        updatePosition(false);
        startAuto();
    });
}
